import React from "react";
import EvaluationPttScreen from './EvaluationPttScreen';

const EvaluationResultScreen = () => {
  // const getDateWithFormat = (date) => {
  //   let dateResult = new Date();
  //   var dd = String(date.getDate()).padStart(2, '0');
  //   var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  //   var yyyy = date.getFullYear();
  //   // return dateResult = dd + '/' + mm + '/' + yyyy;
  //   return dateResult = yyyy + '/' + mm + '/' + dd;
  // }

  // var date = new Date();
  // var firstDay = getDateWithFormat(new Date(date.getFullYear(), date.getMonth(), 1));
  // var lastDay = getDateWithFormat(new Date(date.getFullYear(), date.getMonth() + 1, 0));
  
  // return <EvaluationPttScreen firstDay={firstDay} lastDay={lastDay} />
  return <EvaluationPttScreen/>
} 

export default EvaluationResultScreen;
